var _rect, _rect2, _text, _text2, _rect3, _rect4, _rect5, _rect6, _text3, _text4, _text5, _text6, _g, _path, _path2, _path3, _path4, _path5, _path6, _rect7, _text7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJiraBoardRoadmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 720,
    viewBox: "0 0 1200 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 720,
    rx: 36,
    fill: "#FFFBF6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 1116,
    height: 636,
    rx: 28,
    fill: "white",
    stroke: "#FFE1BF",
    strokeWidth: 4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 108,
    fill: "#13213F",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 40,
    fontWeight: 700
  }, "JIRA Board, Sprint Flow, and QA Roadmap")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 146,
    fill: "#5B6475",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24
  }, "How backlog items move into sprint planning, execution, testing, and release")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 208,
    width: 222,
    height: 378,
    rx: 24,
    fill: "#F8FBFF",
    stroke: "#D5E4FF",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 208,
    width: 222,
    height: 378,
    rx: 24,
    fill: "#FFF7EA",
    stroke: "#FFE1B0",
    strokeWidth: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 594,
    y: 208,
    width: 222,
    height: 378,
    rx: 24,
    fill: "#F4FCF7",
    stroke: "#D4F1DF",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 854,
    y: 208,
    width: 222,
    height: 378,
    rx: 24,
    fill: "#F8F5FF",
    stroke: "#E2D9FF",
    strokeWidth: 3
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 132,
    y: 258,
    fill: "#173E9F",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: 700
  }, "Backlog")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 386,
    y: 258,
    fill: "#B86414",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: 700
  }, "Sprint")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 666,
    y: 258,
    fill: "#1D7A4D",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: 700
  }, "Testing")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 919,
    y: 258,
    fill: "#724CC7",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: 700
  }, "Release")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 23,
    fill: "#334155"
  }, /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 316
  }, "Story grooming"), /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 356
  }, "Acceptance criteria"), /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 396
  }, "Priority setting"), /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 436
  }, "Dependency review"), /*#__PURE__*/React.createElement("text", {
    x: 362,
    y: 316
  }, "Sprint planning"), /*#__PURE__*/React.createElement("text", {
    x: 362,
    y: 356
  }, "Task breakup"), /*#__PURE__*/React.createElement("text", {
    x: 362,
    y: 396
  }, "Bug linking"), /*#__PURE__*/React.createElement("text", {
    x: 362,
    y: 436
  }, "Daily tracking"), /*#__PURE__*/React.createElement("text", {
    x: 622,
    y: 316
  }, "Test execution"), /*#__PURE__*/React.createElement("text", {
    x: 622,
    y: 356
  }, "Defect logging"), /*#__PURE__*/React.createElement("text", {
    x: 622,
    y: 396
  }, "Retest"), /*#__PURE__*/React.createElement("text", {
    x: 622,
    y: 436
  }, "Regression"), /*#__PURE__*/React.createElement("text", {
    x: 882,
    y: 316
  }, "Fix version"), /*#__PURE__*/React.createElement("text", {
    x: 882,
    y: 356
  }, "Dashboards"), /*#__PURE__*/React.createElement("text", {
    x: 882,
    y: 396
  }, "Open risk review"), /*#__PURE__*/React.createElement("text", {
    x: 882,
    y: 436
  }, "Sign-off status"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297 396H333",
    stroke: "#173E9F",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M557 396H593",
    stroke: "#173E9F",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M817 396H853",
    stroke: "#173E9F",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M333 396L315 383V409L333 396Z",
    fill: "#173E9F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M593 396L575 383V409L593 396Z",
    fill: "#173E9F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M853 396L835 383V409L853 396Z",
    fill: "#173E9F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 498,
    width: 928,
    height: 58,
    rx: 18,
    fill: "#13213F"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 536,
    fill: "white",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24
  }, "QA user experience: check backlog, enter sprint, raise linked bugs, retest fixes, verify release dashboard, and communicate sign-off with evidence.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraBoardRoadmap);
export default __webpack_public_path__ + "static/media/jira-board-roadmap.578b44ea4f7c8f76dd12d9eedea0622c.svg";
export { ForwardRef as ReactComponent };